var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbreviations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.93 2.65C12.73 2.45 12.42 2.45 12.22 2.65L10.21 4.66H14.93L12.93 2.65ZM12.23 21.35C12.43 21.55 12.74 21.55 12.94 21.35L14.92 19.37H10.26L12.23 21.35ZM10.98 17.73C11.58 17.73 11.99 17.13 11.77 16.57L8.04 7.03C7.86 6.57 7.41 6.27 6.92 6.27C6.43 6.27 5.98 6.57 5.8 7.03L2.06 16.56C1.84 17.12 2.25 17.72 2.85 17.72C3.2 17.72 3.52 17.5 3.65 17.17L4.36 15.27H9.47L10.18 17.17C10.31 17.51 10.63 17.73 10.98 17.73ZM4.97 13.64L6.91 8.46L8.85 13.64H4.97ZM21.05 16.14H15.72L21.44 7.85C21.9 7.19 21.42 6.28 20.62 6.28H14.14C13.7 6.28 13.35 6.64 13.35 7.08V7.09C13.35 7.53 13.71 7.89 14.14 7.89H19.23L13.5 16.17C13.04 16.83 13.52 17.74 14.32 17.74H21.04C21.48 17.74 21.83 17.38 21.83 16.95C21.85 16.5 21.49 16.14 21.05 16.14Z",
    fill: "#2D3B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbreviations);
export default __webpack_public_path__ + "static/media/abreviations.d56300687191b00c5c773a8c4680faa9.svg";
export { ForwardRef as ReactComponent };